import LayoutContainer from "containers/Layout/LayoutContainer";
import { CustomerRoute, OnboardingRoute } from "helper/route";
import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Switch } from "react-router-dom";
import SentimentTrackerOnboardingNavigator from "./SentimentTrackerOnboardingNavigator";
import Dashboard from "containers/SentimentTracker/sentimentTrackerOnboarding/Dashboard";

const SentimentTrackerNavigator = (props) => {
  const { match } = props;

  // const auth = useSelector((state) => state.customer);
  const isAuthenticated = useSelector(
    (state) => state.customer.isAuthenticated
  );

  // Product onboaridng completed
  const isPortfolioOnboardingCompleted = useSelector(
    (state) => state.onboarding.isOnboardingCompleted
  );
  const isRMSonboardingCompleted = useSelector(
    (state) => state.jarvisRMS.rmsOnboarding.isOnboardingCompleted
  );
  const isOnestockonboardingCompleted = useSelector(
    (state) => state.jarvisOnestock.onestockOnboarding.isOnboardingCompleted
  );
  const isPrimeonboardingCompleted = useSelector(
    (state) => state.jarvisPrime.primeOnboarding.isPrimeOnboardingCompleted
  );
  const isSentimentTrackerOnboardingCompleted = useSelector(
    (state) =>
      state.sentimentTracker.sentimentTrackerOnboarding.isOnboardingCompleted
  );

  const isPhcOnboardingCompleted = useSelector(
    (state) => state.PHC.PHCOnboarding.isOnboardingCompleted
  );

  const anyOnboardingCompleted =
    isPortfolioOnboardingCompleted ||
    isRMSonboardingCompleted ||
    isOnestockonboardingCompleted ||
    isPrimeonboardingCompleted ||
    isSentimentTrackerOnboardingCompleted ||
    isPhcOnboardingCompleted;

  const redirectTo = () => {
    let restPath = "dashboard";
    if (!isSentimentTrackerOnboardingCompleted) {
      restPath = "onboarding/overview";
    }

    return `${match.path}/${restPath}`;
  };

  return (
    // new code to redirect if any onboarding completed  /customer/dashboard
    // old code to redirect if any onboarding completed  ${match.path}/dashboard
    <Switch>
      <Redirect exact from={match.path} to={redirectTo()} />
      <OnboardingRoute
        isAuthenticated={isAuthenticated}
        isOnboardingCompleted={isSentimentTrackerOnboardingCompleted}
        redirectOnboardingIncomplete={`/customer/dashboard`}
        path={`${match.path}/onboarding`}
        component={SentimentTrackerOnboardingNavigator}
      />
      <LayoutContainer {...props}>
        <Switch>
          <CustomerRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={anyOnboardingCompleted}
            redirectOnboardingCompleted={`${match.path}/onboarding`}
            path={`${match.path}/dashboard`}
            component={Dashboard}
          />
        </Switch>
      </LayoutContainer>
    </Switch>
  );
};

export default SentimentTrackerNavigator;
